import { render, staticRenderFns } from "./ModalHeader.vue?vue&type=template&id=1ffbf387&scoped=true"
import script from "./ModalHeader.vue?vue&type=script&lang=js"
export * from "./ModalHeader.vue?vue&type=script&lang=js"
import style0 from "./ModalHeader.vue?vue&type=style&index=0&id=1ffbf387&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffbf387",
  null
  
)

export default component.exports